enum MEMBER_TYPE {
    USER = 'user',
    GROUP = 'group',
    CLASS = 'class',
    DEPARTMENT = 'department',
}
interface IAccountInfo {
    id: string;
    account: string;
    account_type: MEMBER_TYPE;
    avatar: string;
    email: string;
    user_num?: number;
    name?: string;
    login_name?: string;
    is_exist: number;
    user_level?: string;
    show_user_level?: string;
}

export { MEMBER_TYPE, IAccountInfo };
